import React from 'react'

import Section from '../../components/Section'

export default function SharedModulesContent(data?: ZionCMSSection): JSX.Element {
  if (!data) {
    return <></>
  }
  return <Section {...data} />
}
